module.exports = __webpack_public_path__ + "static/media/playstore_new.b25564fb.svg";